import IGroup from "../models/IGroup";
import IErrorResponse from "../models/networking/IErrorResponse";
import networkService from "./networkService";

class GroupService {

    async getGroups(): Promise<IGroup[]> {
        const response = await networkService.get<IGroup[]>('/groups');
        if (response.isSuccessful)  {
            return response.status === 200 
                ? response.data as IGroup[]
                : [];
        } else {
            const error = response.data as IErrorResponse;
            throw new Error(error.message);
        }
    }

}

const groupService = new GroupService();
export default groupService;